/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Docs_CountInputs */

const en_orders_docs_count = /** @type {(inputs: Orders_Docs_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Docs (${i?.count})`)
};

const es_orders_docs_count = /** @type {(inputs: Orders_Docs_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Docs (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Docs ({count})" |
*
* @param {Orders_Docs_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_docs_count = /** @type {((inputs: Orders_Docs_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Docs_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_docs_count(inputs)
	return es_orders_docs_count(inputs)
});